var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 144,
    viewBox: "0 0 217 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 109.5V117.01C48 119.09 55.21 120.77 64.11 120.77C73.01 120.77 80.22 119.09 80.22 117.01V109.5",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 109.5V117.01C48 119.09 55.21 120.77 64.11 120.77C73.01 120.77 80.22 119.09 80.22 117.01V109.5",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 101.62V109.13C48 111.21 55.21 112.89 64.11 112.89C73.01 112.89 80.22 111.21 80.22 109.13V101.62",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 101.62V109.13C48 111.21 55.21 112.89 64.11 112.89C73.01 112.89 80.22 111.21 80.22 109.13V101.62",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 110.99V103.22",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 111.9V104.98",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 112.3V105.37",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 112.3V105.37",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 112.3V105.37",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 112.3V105.37",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 112.3V105.37",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 111.9V104.98",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 110.71V103.79",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 118.87V111.1",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 119.78V112.86",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 120.18V113.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 120.18V113.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 120.18V113.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 120.18V113.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 120.18V113.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 119.78V112.86",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 118.59V111.67",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 94.3398V101.85C48 103.93 55.21 105.61 64.11 105.61C73.01 105.61 80.22 103.93 80.22 101.85V94.3398",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 94.3398V101.85C48 103.93 55.21 105.61 64.11 105.61C73.01 105.61 80.22 103.93 80.22 101.85V94.3398",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 86.46V93.97C48 96.05 55.21 97.73 64.11 97.73C73.01 97.73 80.22 96.05 80.22 93.97V86.46",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 86.46V93.97C48 96.05 55.21 97.73 64.11 97.73C73.01 97.73 80.22 96.05 80.22 93.97V86.46",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 95.8301V88.0701",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 96.7499V89.4199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 97.14V89.72",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 97.1399V89.8799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 97.14V89.72",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 97.1399V89.8799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 97.1399V89.8799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 96.75V89.47",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 95.5599V88.6399",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 103.72V95.95",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 104.63V97.1399",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 105.02V98.0999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 105.02V98.0999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 105.02V98.0999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 105.02V98.0999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 105.02V98.0999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 104.63V97.71",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 103.44V96.52",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 78.4399V85.9499C48 88.0299 55.21 89.7099 64.11 89.7099C73.01 89.7099 80.22 88.0299 80.22 85.9499V78.4399",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 78.4399V85.9499C48 88.0299 55.21 89.7099 64.11 89.7099C73.01 89.7099 80.22 88.0299 80.22 85.9499V78.4399",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 87.82V80.05",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 88.73V81.24",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 89.12V82.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 89.12V82.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 89.12V82.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 89.12V82.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 89.12V82.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 88.7301V81.8101",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 87.5401V80.6201",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 70.5601V78.0701C48 80.1501 55.21 81.8301 64.11 81.8301C73.01 81.8301 80.22 80.1501 80.22 78.0701V70.5601",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 70.5601V78.0701C48 80.1501 55.21 81.8301 64.11 81.8301C73.01 81.8301 80.22 80.1501 80.22 78.0701V70.5601",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 79.9302V72.1702",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 80.8502V73.9302",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 81.2401V74.3201",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 81.2401V74.3201",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 81.2401V74.3201",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 81.2401V74.3201",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 81.2401V74.3201",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 80.8502V73.9302",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 79.66V72.74",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 63.2V70.7099C48 72.7899 55.21 74.47 64.11 74.47C73.01 74.47 80.22 72.7899 80.22 70.7099V63.2",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 63.2V70.7099C48 72.7899 55.21 74.47 64.11 74.47C73.01 74.47 80.22 72.7899 80.22 70.7099V63.2",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 72.5701V64.8101",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 73.4901V66.5701",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 73.88V66.96",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 73.88V66.96",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 73.88V66.96",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 73.88V66.96",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 73.88V66.96",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 73.4901V66.5701",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 72.3001V65.3801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 55.3201V62.8301C48 64.9101 55.21 66.5901 64.11 66.5901C73.01 66.5901 80.22 64.9101 80.22 62.8301V55.3201",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 55.3201V62.8301C48 64.9101 55.21 66.5901 64.11 66.5901C73.01 66.5901 80.22 64.9101 80.22 62.8301V55.3201",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 64.6902V56.9302",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 65.6102V58.6902",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 66.0001V59.0801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 66.0001V59.0801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 66.0001V59.0801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 66.0001V59.0801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 66.0001V59.0801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 65.6102V58.6902",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 64.42V57.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 48V55.51C48 57.59 55.21 59.27 64.11 59.27C73.01 59.27 80.22 57.59 80.22 55.51V48",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 48V55.51C48 57.59 55.21 59.27 64.11 59.27C73.01 59.27 80.22 57.59 80.22 55.51V48",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 40.1201V47.6301C48 49.7101 55.21 51.3901 64.11 51.3901C73.01 51.3901 80.22 49.7101 80.22 47.6301V40.1201",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 40.1201V47.6301C48 49.7101 55.21 51.3901 64.11 51.3901C73.01 51.3901 80.22 49.7101 80.22 47.6301V40.1201",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 31.4102V39.6202C48 41.8902 55.21 43.7302 64.11 43.7302C73.01 43.7302 80.22 41.8902 80.22 39.6202V31.4102",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 31.4102V39.6202C48 41.8902 55.21 43.7302 64.11 43.7302C73.01 43.7302 80.22 41.8902 80.22 39.6202V31.4102",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 41.8301V34.0601",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 42.7401V35.8201",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 43.1302V36.2102",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 43.1302V36.2102",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 43.1302V36.2102",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 43.1302V36.2102",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 43.1302V36.2102",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 42.7401V35.8201",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 41.5501V34.6301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 49.49V41.73",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 50.41V43.49",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 50.8001V43.8801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 50.8001V43.8801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 50.8001V43.8801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 50.8001V43.8801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 50.8001V43.8801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 50.41V43.49",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 49.2201V42.3",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1201 57.3701V49.6101",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 58.2901V51.3701",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 58.68V51.76",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8501 58.68V51.76",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4902 58.68V51.76",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 58.68V51.76",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 58.68V51.76",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 58.2901V51.3701",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5698 57.1002V50.1802",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.11 36.2201C73.0073 36.2201 80.22 34.0666 80.22 31.4101C80.22 28.7536 73.0073 26.6001 64.11 26.6001C55.2127 26.6001 48 28.7536 48 31.4101C48 34.0666 55.2127 36.2201 64.11 36.2201Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 83.3899V90.8999C85.5801 92.9799 92.7901 94.6599 101.69 94.6599C110.59 94.6599 117.8 92.9799 117.8 90.8999V83.3899",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 83.3899V90.8999C85.5801 92.9799 92.7901 94.6599 101.69 94.6599C110.59 94.6599 117.8 92.9799 117.8 90.8999V83.3899",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 75.51V83.02C85.5801 85.1 92.7901 86.78 101.69 86.78C110.59 86.78 117.8 85.1 117.8 83.02V75.51",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 75.51V83.02C85.5801 85.1 92.7901 86.78 101.69 86.78C110.59 86.78 117.8 85.1 117.8 83.02V75.51",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 84.8801V77.1201",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 85.7999V78.8799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 86.19V79.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 86.19V79.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 86.19V79.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 86.19V79.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 86.19V79.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 85.7999V78.8799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 84.6099V77.6899",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 92.77V85",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 93.68V86.76",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 94.0699V87.1499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 94.0699V87.1499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 94.0699V87.1499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 94.0699V87.1499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 94.0699V87.1499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 93.68V86.76",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 92.4901V85.5701",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 68.2397V75.7497C85.5801 77.8297 92.7901 79.5098 101.69 79.5098C110.59 79.5098 117.8 77.8297 117.8 75.7497V68.2397",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 68.2397V75.7497C85.5801 77.8297 92.7901 79.5098 101.69 79.5098C110.59 79.5098 117.8 77.8297 117.8 75.7497V68.2397",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 60.3599V67.8699C85.5801 69.9499 92.7901 71.6299 101.69 71.6299C110.59 71.6299 117.8 69.9499 117.8 67.8699V60.3599",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 60.3599V67.8699C85.5801 69.9499 92.7901 71.6299 101.69 71.6299C110.59 71.6299 117.8 69.9499 117.8 67.8699V60.3599",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 69.73V61.97",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 70.6498V63.3098",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 71.0399V63.6099",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 71.0398V63.7698",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 71.0399V63.6099",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 71.0398V63.7698",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 71.0398V63.7698",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 70.6499V63.3699",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 69.4598V62.5398",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 77.6099V69.8499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 78.5298V71.0398",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 78.9198V71.9998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 78.9198V71.9998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 78.9198V71.9998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 78.9198V71.9998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 78.9198V71.9998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 78.5299V71.6099",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 77.3399V70.4199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 52.3398V59.8498C85.5801 61.9298 92.7901 63.6098 101.69 63.6098C110.59 63.6098 117.8 61.9298 117.8 59.8498V52.3398",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 52.3398V59.8498C85.5801 61.9298 92.7901 63.6098 101.69 63.6098C110.59 63.6098 117.8 61.9298 117.8 59.8498V52.3398",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 61.7099V53.95",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 62.6299V55.1399",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 63.0199V56.0999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 63.0199V56.0999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 63.0199V56.0999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 63.0199V56.0999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 63.0199V56.0999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 62.63V55.71",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 61.44V54.52",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 44.46V51.97C85.5801 54.05 92.7901 55.73 101.69 55.73C110.59 55.73 117.8 54.05 117.8 51.97V44.46",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 44.46V51.97C85.5801 54.05 92.7901 55.73 101.69 55.73C110.59 55.73 117.8 54.05 117.8 51.97V44.46",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 53.8301V46.0701",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 54.7501V47.8301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 55.14V48.22",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 55.14V48.22",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 55.14V48.22",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 55.14V48.22",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 55.14V48.22",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 54.7501V47.8301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 53.5599V46.6399",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 37.0999V44.6099C85.5801 46.6899 92.7901 48.3699 101.69 48.3699C110.59 48.3699 117.8 46.6899 117.8 44.6099V37.0999",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 37.0999V44.6099C85.5801 46.6899 92.7901 48.3699 101.69 48.3699C110.59 48.3699 117.8 46.6899 117.8 44.6099V37.0999",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 46.47V38.71",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 47.39V40.46",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 47.7799V40.8599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 47.7799V40.8599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 47.7799V40.8599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 47.7799V40.8599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 47.7799V40.8599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 47.39V40.46",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 46.2V39.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 29.22V36.73C85.5801 38.81 92.7901 40.49 101.69 40.49C110.59 40.49 117.8 38.81 117.8 36.73V29.22",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 29.22V36.73C85.5801 38.81 92.7901 40.49 101.69 40.49C110.59 40.49 117.8 38.81 117.8 36.73V29.22",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 38.5901V30.8301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 39.5101V32.5801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 39.9V32.98",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 39.9V32.98",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 39.9V32.98",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 39.9V32.98",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 39.9V32.98",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 39.5101V32.5801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 38.3099V31.3899",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 21.8999V29.4099C85.5801 31.4899 92.7901 33.1699 101.69 33.1699C110.59 33.1699 117.8 31.4899 117.8 29.4099V21.8999",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 21.8999V29.4099C85.5801 31.4899 92.7901 33.1699 101.69 33.1699C110.59 33.1699 117.8 31.4899 117.8 29.4099V21.8999",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 14.02V21.53C85.5801 23.61 92.7901 25.29 101.69 25.29C110.59 25.29 117.8 23.61 117.8 21.53V14.02",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 14.02V21.53C85.5801 23.61 92.7901 25.29 101.69 25.29C110.59 25.29 117.8 23.61 117.8 21.53V14.02",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 5.31006V13.5201C85.5801 15.7901 92.7901 17.6301 101.69 17.6301C110.59 17.6301 117.8 15.7901 117.8 13.5201V5.31006",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5801 5.31006V13.5201C85.5801 15.7901 92.7901 17.6301 101.69 17.6301C110.59 17.6301 117.8 15.7901 117.8 13.5201V5.31006",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 15.72V7.95996",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 16.64V9.71997",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 17.0301V10.1101",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 17.0301V10.1101",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 17.0301V10.1101",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 17.0301V10.1101",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 17.0301V10.1101",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 16.64V9.71997",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 15.45V8.53003",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 23.3899V15.6299",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 24.3099V17.3799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 24.7V17.78",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 24.7V17.78",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 24.7V17.78",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 24.7V17.78",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 24.7V17.78",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 24.3099V17.3799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 23.1199V16.1899",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 31.27V23.51",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 32.19V25.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 32.5799V25.6599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44 32.5799V25.6599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 32.5799V25.6599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71 32.5799V25.6599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1899 32.5799V25.6599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 32.19V25.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 31.0001V24.0801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.69 10.12C110.587 10.12 117.8 7.96649 117.8 5.31C117.8 2.65351 110.587 0.5 101.69 0.5C92.7928 0.5 85.5801 2.65351 85.5801 5.31C85.5801 7.96649 92.7928 10.12 101.69 10.12Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 120.32V127.83C38.5 129.91 45.71 131.59 54.61 131.59C63.51 131.59 70.72 129.91 70.72 127.83V120.32",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 120.32V127.83C38.5 129.91 45.71 131.59 54.61 131.59C63.51 131.59 70.72 129.91 70.72 127.83V120.32",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6299 129.69V121.93",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2402 130.61V123.12",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7202 131V124.08",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3599 131V124.08",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9902 131V124.08",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6299 131V124.08",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1099 131V124.08",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5898 130.61V123.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0801 129.42V122.49",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 112.44V119.95C38.5 122.03 45.71 123.71 54.61 123.71C63.51 123.71 70.72 122.03 70.72 119.95V112.44",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 112.44V119.95C38.5 122.03 45.71 123.71 54.61 123.71C63.51 123.71 70.72 122.03 70.72 119.95V112.44",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6299 121.81V114.04",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2402 122.72V115.8",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7202 123.12V116.19",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3599 123.12V116.19",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9902 123.12V116.19",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6299 123.12V116.19",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1099 123.12V116.19",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5898 122.72V115.8",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0801 121.53V114.61",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 105.08V112.59C38.5 114.67 45.71 116.35 54.61 116.35C63.51 116.35 70.72 114.67 70.72 112.59V105.08",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 105.08V112.59C38.5 114.67 45.71 116.35 54.61 116.35C63.51 116.35 70.72 114.67 70.72 112.59V105.08",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6299 114.45V106.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2402 115.36V108.44",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7202 115.75V108.83",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3599 115.75V108.83",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9902 115.75V108.83",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6299 115.75V108.83",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1099 115.75V108.83",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5898 115.36V108.44",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0801 114.17V107.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 97.1899V104.7C38.5 106.78 45.71 108.46 54.61 108.46C63.51 108.46 70.72 106.78 70.72 104.7V97.1899",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 97.1899V104.7C38.5 106.78 45.71 108.46 54.61 108.46C63.51 108.46 70.72 106.78 70.72 104.7V97.1899",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6299 106.57V98.8",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2402 107.48V100.56",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7202 107.87V100.95",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3599 107.87V100.95",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9902 107.87V100.95",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6299 107.87V100.95",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1099 107.87V100.95",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5898 107.48V100.56",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0801 106.29V99.3699",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 89.8799V97.3899C38.5 99.4699 45.71 101.15 54.61 101.15C63.51 101.15 70.72 99.4699 70.72 97.3899V89.8799",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 89.8799V97.3899C38.5 99.4699 45.71 101.15 54.61 101.15C63.51 101.15 70.72 99.4699 70.72 97.3899V89.8799",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 82V89.51C38.5 91.59 45.71 93.27 54.61 93.27C63.51 93.27 70.72 91.59 70.72 89.51V82",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 82V89.51C38.5 91.59 45.71 93.27 54.61 93.27C63.51 93.27 70.72 91.59 70.72 89.51V82",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 73.28V81.49C38.5 83.76 45.71 85.6 54.61 85.6C63.51 85.6 70.72 83.76 70.72 81.49V73.28",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 73.28V81.49C38.5 83.76 45.71 85.6 54.61 85.6C63.51 85.6 70.72 83.76 70.72 81.49V73.28",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6299 83.6999V75.9399",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2402 84.62V77.7",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7202 85.0098V78.0898",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3599 85.0098V78.0898",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9902 85.0098V78.0898",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6299 85.0098V78.0898",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1099 85.0098V78.0898",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5898 84.62V77.7",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0801 83.43V76.51",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6299 91.3699V83.5999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2402 92.2799V85.3599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7202 92.67V85.75",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3599 92.67V85.75",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9902 92.67V85.75",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6299 92.67V85.75",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1099 92.67V85.75",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5898 92.2799V85.3599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0801 91.0899V84.1699",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6299 99.25V91.48",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2402 100.16V93.24",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7202 100.56V93.6299",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3599 100.56V93.6299",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9902 100.56V93.6299",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6299 100.56V93.6299",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1099 100.56V93.6299",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5898 100.16V93.24",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0801 98.97V92.05",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6198 78.09C63.5171 78.09 70.7298 75.9365 70.7298 73.28C70.7298 70.6235 63.5171 68.47 54.6198 68.47C45.7225 68.47 38.5098 70.6235 38.5098 73.28C38.5098 75.9365 45.7225 78.09 54.6198 78.09Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 120.8V128.31C71.2202 130.39 78.4302 132.07 87.3302 132.07C96.2302 132.07 103.44 130.39 103.44 128.31V120.8",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 120.8V128.31C71.2202 130.39 78.4302 132.07 87.3302 132.07C96.2302 132.07 103.44 130.39 103.44 128.31V120.8",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 112.92V120.43C71.2202 122.51 78.4302 124.19 87.3302 124.19C96.2302 124.19 103.44 122.51 103.44 120.43V112.92",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 112.92V120.43C71.2202 122.51 78.4302 124.19 87.3302 124.19C96.2302 124.19 103.44 122.51 103.44 120.43V112.92",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 122.29V114.52",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 123.21V116.28",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 123.6V116.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 123.6V116.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 123.6V116.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 123.6V116.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 123.6V116.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 123.21V116.28",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 122.01V115.09",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 130.17V122.41",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 131.09V124.16",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 131.48V124.56",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 131.48V124.56",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 131.48V124.56",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 131.48V124.56",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 131.48V124.56",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 131.09V124.16",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 129.9V122.97",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 105.65V113.16C71.2202 115.24 78.4302 116.92 87.3302 116.92C96.2302 116.92 103.44 115.24 103.44 113.16V105.65",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 105.65V113.16C71.2202 115.24 78.4302 116.92 87.3302 116.92C96.2302 116.92 103.44 115.24 103.44 113.16V105.65",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 97.7698V105.28C71.2202 107.36 78.4302 109.04 87.3302 109.04C96.2302 109.04 103.44 107.36 103.44 105.28V97.7698",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 97.7698V105.28C71.2202 107.36 78.4302 109.04 87.3302 109.04C96.2302 109.04 103.44 107.36 103.44 105.28V97.7698",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 107.14V99.3699",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 108.05V100.72",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 108.44V101.02",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 108.44V101.18",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 108.44V101.02",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 108.44V101.18",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 108.44V101.18",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 108.05V100.78",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 106.86V99.9397",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 115.02V107.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 115.93V108.44",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 116.32V109.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 116.32V109.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 116.32V109.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 116.32V109.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 116.32V109.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 115.93V109.01",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 114.74V107.82",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 89.7498V97.2598C71.2202 99.3398 78.4302 101.02 87.3302 101.02C96.2302 101.02 103.44 99.3398 103.44 97.2598V89.7498",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 89.7498V97.2598C71.2202 99.3398 78.4302 101.02 87.3302 101.02C96.2302 101.02 103.44 99.3398 103.44 97.2598V89.7498",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 99.1199V91.3499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 100.03V92.5398",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 100.42V93.4998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 100.42V93.4998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 100.42V93.4998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 100.42V93.4998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 100.42V93.4998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 100.03V93.1099",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 98.8399V91.9199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 81.8699V89.3799C71.2202 91.4599 78.4302 93.1399 87.3302 93.1399C96.2302 93.1399 103.44 91.4599 103.44 89.3799V81.8699",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 81.8699V89.3799C71.2202 91.4599 78.4302 93.1399 87.3302 93.1399C96.2302 93.1399 103.44 91.4599 103.44 89.3799V81.8699",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 91.24V83.47",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 92.15V85.23",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 92.5399V85.6199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 92.5399V85.6199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 92.5399V85.6199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 92.5399V85.6199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 92.5399V85.6199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 92.15V85.23",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 90.9598V84.0398",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 74.4998V82.0098C71.2202 84.0898 78.4302 85.7698 87.3302 85.7698C96.2302 85.7698 103.44 84.0898 103.44 82.0098V74.4998",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 74.4998V82.0098C71.2202 84.0898 78.4302 85.7698 87.3302 85.7698C96.2302 85.7698 103.44 84.0898 103.44 82.0098V74.4998",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 83.8699V76.1099",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 84.7899V77.8699",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 85.1798V78.2598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 85.1798V78.2598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 85.1798V78.2598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 85.1798V78.2598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 85.1798V78.2598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 84.7899V77.8699",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 83.5999V76.6799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 66.6199V74.1299C71.2202 76.2099 78.4302 77.8899 87.3302 77.8899C96.2302 77.8899 103.44 76.2099 103.44 74.1299V66.6199",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 66.6199V74.1299C71.2202 76.2099 78.4302 77.8899 87.3302 77.8899C96.2302 77.8899 103.44 76.2099 103.44 74.1299V66.6199",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 75.99V68.23",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 76.9098V69.9897",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 77.2999V70.3799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 77.2999V70.3799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 77.2999V70.3799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 77.2999V70.3799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 77.2999V70.3799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 76.9098V69.9897",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 75.7198V68.7998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 59.2998V66.8098C71.2202 68.8898 78.4302 70.5698 87.3302 70.5698C96.2302 70.5698 103.44 68.8898 103.44 66.8098V59.2998",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 59.2998V66.8098C71.2202 68.8898 78.4302 70.5698 87.3302 70.5698C96.2302 70.5698 103.44 68.8898 103.44 66.8098V59.2998",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 51.4199V58.9299C71.2202 61.0099 78.4302 62.6899 87.3302 62.6899C96.2302 62.6899 103.44 61.0099 103.44 58.9299V51.4199",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 51.4199V58.9299C71.2202 61.0099 78.4302 62.6899 87.3302 62.6899C96.2302 62.6899 103.44 61.0099 103.44 58.9299V51.4199",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 42.71V50.92C71.2202 53.19 78.4302 55.03 87.3302 55.03C96.2302 55.03 103.44 53.19 103.44 50.92V42.71",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2202 42.71V50.92C71.2202 53.19 78.4302 55.03 87.3302 55.03C96.2302 55.03 103.44 53.19 103.44 50.92V42.71",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 53.1299V45.3599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 54.0399V47.1199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 54.44V47.51",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 54.44V47.51",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 54.44V47.51",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 54.44V47.51",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 54.44V47.51",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 54.0399V47.1199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 52.8499V45.9299",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 60.7898V53.0298",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 61.7098V54.7898",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 62.0999V55.1799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 62.0999V55.1799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 62.0999V55.1799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 62.0999V55.1799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 62.0999V55.1799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 61.7098V54.7898",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 60.5199V53.5999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 68.6699V60.9099",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9502 69.5899V62.6699",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4404 69.9798V63.0598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0703 69.9798V63.0598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7104 69.9798V63.0598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 69.9798V63.0598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8203 69.9798V63.0598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 69.5899V62.6699",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79 68.4V61.48",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3302 47.5199C96.2275 47.5199 103.44 45.3664 103.44 42.7099C103.44 40.0534 96.2275 37.8999 87.3302 37.8999C78.4329 37.8999 71.2202 40.0534 71.2202 42.7099C71.2202 45.3664 78.4329 47.5199 87.3302 47.5199Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 117.62V125.13C117.45 127.21 124.66 128.89 133.56 128.89C142.46 128.89 149.67 127.21 149.67 125.13V117.62",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 117.62V125.13C117.45 127.21 124.66 128.89 133.56 128.89C142.46 128.89 149.67 127.21 149.67 125.13V117.62",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 109.74V117.25C117.45 119.33 124.66 121.01 133.56 121.01C142.46 121.01 149.67 119.33 149.67 117.25V109.74",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 109.74V117.25C117.45 119.33 124.66 121.01 133.56 121.01C142.46 121.01 149.67 119.33 149.67 117.25V109.74",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 119.11V111.35",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 120.03V113.11",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 120.42V113.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 120.42V113.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 120.42V113.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 120.42V113.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 120.42V113.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 120.03V113.11",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 118.84V111.92",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 126.99V119.23",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 127.91V120.99",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 128.3V121.38",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 128.3V121.38",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 128.3V121.38",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 128.3V121.38",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 128.3V121.38",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 127.91V120.99",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 126.72V119.8",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 102.47V109.98C117.45 112.06 124.66 113.74 133.56 113.74C142.46 113.74 149.67 112.06 149.67 109.98V102.47",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 102.47V109.98C117.45 112.06 124.66 113.74 133.56 113.74C142.46 113.74 149.67 112.06 149.67 109.98V102.47",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 94.5898V102.1C117.45 104.18 124.66 105.86 133.56 105.86C142.46 105.86 149.67 104.18 149.67 102.1V94.5898",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 94.5898V102.1C117.45 104.18 124.66 105.86 133.56 105.86C142.46 105.86 149.67 104.18 149.67 102.1V94.5898",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 103.96V96.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 104.88V97.5398",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 105.27V97.8398",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 105.27V97.9998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 105.27V97.8398",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 105.27V97.9998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 105.27V97.9998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 104.88V97.5999",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 103.68V96.7598",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 111.84V104.08",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 112.76V105.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 113.15V106.23",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 113.15V106.23",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 113.15V106.23",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 113.15V106.23",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 113.15V106.23",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 112.76V105.84",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 111.57V104.64",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 86.5698V94.0798C117.45 96.1598 124.66 97.8398 133.56 97.8398C142.46 97.8398 149.67 96.1598 149.67 94.0798V86.5698",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 86.5698V94.0798C117.45 96.1598 124.66 97.8398 133.56 97.8398C142.46 97.8398 149.67 96.1598 149.67 94.0798V86.5698",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 95.9399V88.1799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 96.8599V89.3699",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 97.2498V90.3298",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 97.2498V90.3298",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 97.2498V90.3298",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 97.2498V90.3298",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 97.2498V90.3298",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 96.8599V89.9399",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 95.67V88.74",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 78.6899V86.1999C117.45 88.2799 124.66 89.9599 133.56 89.9599C142.46 89.9599 149.67 88.2799 149.67 86.1999V78.6899",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 78.6899V86.1999C117.45 88.2799 124.66 89.9599 133.56 89.9599C142.46 89.9599 149.67 88.2799 149.67 86.1999V78.6899",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 88.06V80.3",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 88.98V82.05",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 89.37V82.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 89.37V82.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 89.37V82.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 89.37V82.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 89.37V82.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 88.98V82.05",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 87.7799V80.8599",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 71.3298V78.8398C117.45 80.9198 124.66 82.5998 133.56 82.5998C142.46 82.5998 149.67 80.9198 149.67 78.8398V71.3298",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 71.3298V78.8398C117.45 80.9198 124.66 82.5998 133.56 82.5998C142.46 82.5998 149.67 80.9198 149.67 78.8398V71.3298",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 80.6999V72.9299",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 81.6099V74.6899",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 82.0098V75.0798",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 82.0098V75.0798",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 82.0098V75.0798",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 82.0098V75.0798",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 82.0098V75.0798",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 81.6099V74.6899",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 80.42V73.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 63.45V70.9599C117.45 73.0399 124.66 74.72 133.56 74.72C142.46 74.72 149.67 73.0399 149.67 70.9599V63.45",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 63.45V70.9599C117.45 73.0399 124.66 74.72 133.56 74.72C142.46 74.72 149.67 73.0399 149.67 70.9599V63.45",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 72.82V65.05",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 73.7301V66.8101",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 74.12V67.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 74.12V67.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 74.12V67.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 74.12V67.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 74.12V67.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 73.7301V66.8101",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 72.5399V65.6199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 56.1299V63.6399C117.45 65.7199 124.66 67.3999 133.56 67.3999C142.46 67.3999 149.67 65.7199 149.67 63.6399V56.1299",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 56.1299V63.6399C117.45 65.7199 124.66 67.3999 133.56 67.3999C142.46 67.3999 149.67 65.7199 149.67 63.6399V56.1299",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 48.25V55.76C117.45 57.84 124.66 59.52 133.56 59.52C142.46 59.52 149.67 57.84 149.67 55.76V48.25",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 48.25V55.76C117.45 57.84 124.66 59.52 133.56 59.52C142.46 59.52 149.67 57.84 149.67 55.76V48.25",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 39.53V47.74C117.45 50.01 124.66 51.85 133.56 51.85C142.46 51.85 149.67 50.01 149.67 47.74V39.53",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 39.53V47.74C117.45 50.01 124.66 51.85 133.56 51.85C142.46 51.85 149.67 50.01 149.67 47.74V39.53",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 49.9499V42.1899",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 50.8699V43.95",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 51.2601V44.3401",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 51.2601V44.3401",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 51.2601V44.3401",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 51.2601V44.3401",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 51.2601V44.3401",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 50.8699V43.95",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 49.68V42.76",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 57.6199V49.8499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 58.5299V51.6099",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 58.93V52",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 58.93V52",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 58.93V52",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 58.93V52",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 58.93V52",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 58.5299V51.6099",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 57.3399V50.4199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57 65.5V57.73",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19 66.41V59.49",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 66.8099V59.8799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 66.8099V59.8799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94 66.8099V59.8799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 66.8099V59.8799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06 66.8099V59.8799",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54 66.41V59.49",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.02 65.2201V58.3",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.56 44.34C142.458 44.34 149.67 42.1865 149.67 39.53C149.67 36.8735 142.458 34.72 133.56 34.72C124.663 34.72 117.45 36.8735 117.45 39.53C117.45 42.1865 124.663 44.34 133.56 44.34Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 123.57V131.08C57.6099 133.16 64.8199 134.84 73.7199 134.84C82.6199 134.84 89.8299 133.16 89.8299 131.08V123.57",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 123.57V131.08C57.6099 133.16 64.8199 134.84 73.7199 134.84C82.6199 134.84 89.8299 133.16 89.8299 131.08V123.57",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 115.69V123.2C57.6099 125.28 64.8199 126.96 73.7199 126.96C82.6199 126.96 89.8299 125.28 89.8299 123.2V115.69",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 115.69V123.2C57.6099 125.28 64.8199 126.96 73.7199 126.96C82.6199 126.96 89.8299 125.28 89.8299 123.2V115.69",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 106.98V115.19C57.6099 117.46 64.8199 119.3 73.7199 119.3C82.6199 119.3 89.8299 117.46 89.8299 115.19V106.98",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6099 106.98V115.19C57.6099 117.46 64.8199 119.3 73.7199 119.3C82.6199 119.3 89.8299 117.46 89.8299 115.19V106.98",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.73 117.4V109.64",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3398 118.32V111.39",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8198 118.71V111.79",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.46 118.71V111.79",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1001 118.71V111.79",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73 118.71V111.79",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21 118.71V111.79",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6997 118.32V111.39",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1797 117.12V110.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.73 125.06V117.3",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3398 125.98V119.06",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8198 126.37V119.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.46 126.37V119.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1001 126.37V119.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73 126.37V119.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21 126.37V119.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6997 125.98V119.06",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1797 124.79V117.87",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.73 132.95V125.18",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3398 133.86V126.94",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8198 134.25V127.33",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.46 134.25V127.33",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1001 134.25V127.33",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73 134.25V127.33",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21 134.25V127.33",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6997 133.86V126.94",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1797 132.67V125.75",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7199 111.79C82.6172 111.79 89.8299 109.636 89.8299 106.98C89.8299 104.323 82.6172 102.17 73.7199 102.17C64.8226 102.17 57.6099 104.323 57.6099 106.98C57.6099 109.636 64.8226 111.79 73.7199 111.79Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71 120.43V127.94C136.71 130.02 143.92 131.7 152.82 131.7C161.72 131.7 168.93 130.02 168.93 127.94V120.43",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71 120.43V127.94C136.71 130.02 143.92 131.7 152.82 131.7C161.72 131.7 168.93 130.02 168.93 127.94V120.43",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71 112.55V120.06C136.71 122.14 143.92 123.82 152.82 123.82C161.72 123.82 168.93 122.14 168.93 120.06V112.55",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71 112.55V120.06C136.71 122.14 143.92 123.82 152.82 123.82C161.72 123.82 168.93 122.14 168.93 120.06V112.55",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71 103.83V112.04C136.71 114.31 143.92 116.15 152.82 116.15C161.72 116.15 168.93 114.31 168.93 112.04V103.83",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71 103.83V112.04C136.71 114.31 143.92 116.15 152.82 116.15C161.72 116.15 168.93 114.31 168.93 112.04V103.83",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.83 114.25V106.49",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.44 115.17V108.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92 115.56V108.64",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56 115.56V108.64",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.19 115.56V108.64",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83 115.56V108.64",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.31 115.56V108.64",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.79 115.17V108.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.28 113.98V107.06",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.83 121.92V114.15",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.44 122.83V115.91",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92 123.22V116.3",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56 123.22V116.3",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.19 123.22V116.3",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83 123.22V116.3",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.31 123.22V116.3",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.79 122.83V115.91",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.28 121.64V114.72",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.83 129.8V122.03",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.44 130.71V123.79",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92 131.11V124.18",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56 131.11V124.18",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.19 131.11V124.18",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83 131.11V124.18",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.31 131.11V124.18",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.79 130.71V123.79",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.28 129.52V122.6",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.82 108.64C161.717 108.64 168.93 106.487 168.93 103.83C168.93 101.174 161.717 99.02 152.82 99.02C143.923 99.02 136.71 101.174 136.71 103.83C136.71 106.487 143.923 108.64 152.82 108.64Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8398 131.09V139.3C29.8398 141.57 37.0498 143.41 45.9498 143.41C54.8498 143.41 62.0598 141.57 62.0598 139.3V131.09",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8398 131.09V139.3C29.8398 141.57 37.0498 143.41 45.9498 143.41C54.8498 143.41 62.0598 141.57 62.0598 139.3V131.09",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.96 141.51V133.74",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5801 142.42V135.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0601 142.82V135.89",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6997 142.82V135.89",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3301 142.82V135.89",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9697 142.82V135.89",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4497 142.82V135.89",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9297 142.42V135.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4097 141.23V134.31",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9498 135.9C54.8472 135.9 62.0598 133.747 62.0598 131.09C62.0598 128.434 54.8472 126.28 45.9498 126.28C37.0525 126.28 29.8398 128.434 29.8398 131.09C29.8398 133.747 37.0525 135.9 45.9498 135.9Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92 127.04V135.25C159.92 137.52 167.13 139.36 176.03 139.36C184.93 139.36 192.14 137.52 192.14 135.25V127.04",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92 127.04V135.25C159.92 137.52 167.13 139.36 176.03 139.36C184.93 139.36 192.14 137.52 192.14 135.25V127.04",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.04 137.45V129.69",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66 138.37V131.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.14 138.76V131.84",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.78 138.76V131.84",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.41 138.76V131.84",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.05 138.76V131.84",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.53 138.76V131.84",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.01 138.37V131.45",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5 137.18V130.26",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.04 131.85C184.937 131.85 192.15 129.696 192.15 127.04C192.15 124.383 184.937 122.23 176.04 122.23C167.142 122.23 159.93 124.383 159.93 127.04C159.93 129.696 167.142 131.85 176.04 131.85Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 114.7V121.51C0.5 123.39 6.49 124.92 13.87 124.92C21.25 124.92 27.24 123.39 27.24 121.51V114.7",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 114.7V121.51C0.5 123.39 6.49 124.92 13.87 124.92C21.25 124.92 27.24 123.39 27.24 121.51V114.7",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4902 123.34V116.9",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6802 124.1V118.36",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7598 124.43V118.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9702 124.43V118.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1802 124.43V118.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3901 124.43V118.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47021 124.43V118.68",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5498 124.1V118.36",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62988 123.11V117.37",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.87 118.69C21.254 118.69 27.24 116.904 27.24 114.7C27.24 112.496 21.254 110.71 13.87 110.71C6.48595 110.71 0.5 112.496 0.5 114.7C0.5 116.904 6.48595 118.69 13.87 118.69Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.95 98.6301V104.74C191.95 106.43 197.32 107.8 203.94 107.8C210.56 107.8 215.93 106.43 215.93 104.74V98.6301",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.95 98.6301V104.74C191.95 106.43 197.32 107.8 203.94 107.8C210.56 107.8 215.93 106.43 215.93 104.74V98.6301",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.36 106.38V100.6",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.84 107.06V101.91",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.22 107.35V102.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.72 107.35V102.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.21 107.35V102.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.71 107.35V102.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.09 107.35V102.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.48 107.06V101.91",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.86 106.18V101.03",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.93 102.21C210.552 102.21 215.92 100.607 215.92 98.63C215.92 96.6529 210.552 95.05 203.93 95.05C197.308 95.05 191.94 96.6529 191.94 98.63C191.94 100.607 197.308 102.21 203.93 102.21Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 122.77V130.28C101.34 132.36 108.55 134.04 117.45 134.04C126.35 134.04 133.56 132.36 133.56 130.28V122.77",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 122.77V130.28C101.34 132.36 108.55 134.04 117.45 134.04C126.35 134.04 133.56 132.36 133.56 130.28V122.77",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46 132.14V124.38",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07 133.06V125.57",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56 133.45V126.53",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19 133.45V126.53",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83 133.45V126.53",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46 133.45V126.53",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 133.45V126.53",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43 133.06V126.13",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91 131.87V124.94",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 114.89V122.4C101.34 124.48 108.55 126.16 117.45 126.16C126.35 126.16 133.56 124.48 133.56 122.4V114.89",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 114.89V122.4C101.34 124.48 108.55 126.16 117.45 126.16C126.35 126.16 133.56 124.48 133.56 122.4V114.89",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46 124.26V116.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07 125.18V118.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56 125.57V118.65",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19 125.57V118.65",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83 125.57V118.65",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46 125.57V118.65",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 125.57V118.65",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43 125.18V118.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91 123.98V117.06",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 107.53V115.04C101.34 117.12 108.55 118.8 117.45 118.8C126.35 118.8 133.56 117.12 133.56 115.04V107.53",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 107.53V115.04C101.34 117.12 108.55 118.8 117.45 118.8C126.35 118.8 133.56 117.12 133.56 115.04V107.53",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46 116.9V109.13",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07 117.81V110.89",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56 118.2V111.28",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19 118.2V111.28",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83 118.2V111.28",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46 118.2V111.28",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 118.2V111.28",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43 117.81V110.89",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91 116.62V109.7",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 99.6499V107.16C101.34 109.24 108.55 110.92 117.45 110.92C126.35 110.92 133.56 109.24 133.56 107.16V99.6499",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 99.6499V107.16C101.34 109.24 108.55 110.92 117.45 110.92C126.35 110.92 133.56 109.24 133.56 107.16V99.6499",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46 109.02V101.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07 109.93V103.01",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56 110.32V103.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19 110.32V103.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83 110.32V103.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46 110.32V103.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 110.32V103.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43 109.93V103.01",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91 108.74V101.82",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 92.3298V99.8398C101.34 101.92 108.55 103.6 117.45 103.6C126.35 103.6 133.56 101.92 133.56 99.8398V92.3298",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 92.3298V99.8398C101.34 101.92 108.55 103.6 117.45 103.6C126.35 103.6 133.56 101.92 133.56 99.8398V92.3298",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 84.45V91.96C101.34 94.04 108.55 95.72 117.45 95.72C126.35 95.72 133.56 94.04 133.56 91.96V84.45",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 84.45V91.96C101.34 94.04 108.55 95.72 117.45 95.72C126.35 95.72 133.56 94.04 133.56 91.96V84.45",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 75.73V83.94C101.34 86.21 108.55 88.05 117.45 88.05C126.35 88.05 133.56 86.21 133.56 83.94V75.73",
    fill: "#FFD148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 75.73V83.94C101.34 86.21 108.55 88.05 117.45 88.05C126.35 88.05 133.56 86.21 133.56 83.94V75.73",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46 86.1499V78.3899",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07 87.0699V80.1499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56 87.46V80.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19 87.46V80.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83 87.46V80.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46 87.46V80.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 87.46V80.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43 87.0699V80.1499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91 85.88V78.96",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46 93.8198V86.0498",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07 94.7298V87.8098",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56 95.12V88.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19 95.12V88.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83 95.12V88.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46 95.12V88.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 95.12V88.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43 94.7298V87.8098",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91 93.5399V86.6199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46 101.7V93.9299",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07 102.61V95.6899",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56 103.01V96.0798",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19 103.01V96.0798",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83 103.01V96.0798",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46 103.01V96.0798",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 103.01V96.0798",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43 102.61V95.6899",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91 101.42V94.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45 80.5399C126.347 80.5399 133.56 78.3864 133.56 75.7299C133.56 73.0734 126.347 70.9199 117.45 70.9199C108.553 70.9199 101.34 73.0734 101.34 75.7299C101.34 78.3864 108.553 80.5399 117.45 80.5399Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216.42,
    height: 143.91,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrize);
export default __webpack_public_path__ + "static/media/prize.37b74aa169777ce2dfaa47621189e0f5.svg";
export { ForwardRef as ReactComponent };